<script setup>
  import { useRoute } from 'vue-router'
  import Navbar from '@/components/Navbar.vue'
  import Footer from '@/components/Footer.vue'
  import ContactModal from '@/components/ContactModal.vue'

  const route = useRoute()
</script>

<template>
  <Navbar />
  <router-view
    :key="route.path"
  />
  <Footer />
  <ContactModal />
</template>

<style lang="scss">
@import "./scss/style.scss";
</style>
